import { TableHeadersType } from "./tableHeadersType";

export const OPEN_ITEM_HEADER: TableHeadersType[] = [
    {
        "label": "Summary",
        "value": "summary",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Client",
        "value": "client_name",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Job Type (Job Id)",
        "value": "job_type",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "End date",
        "value": "job_end_date",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Due date",
        "value": "first_due_date",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Item (files)",
        "value": "first_item_due",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Add/Modified By",
        "value": "modified_by",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Status",
        "value": "status_code",
        "defaultChecked": true,
        "checked": true
    }
];

export const CLIENT_OPEN_ITEM_HEADERS = [
    {
        "label": "Summary",
        "value": "summary",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Created Date",
        "value": "created_date",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Job Type (Job ID)",
        "value": "job_type",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Period End",
        "value": "period_end",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Due Date",
        "value": "due_date",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Currently Responsible",
        "value": "responsible_user",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Item (Files)",
        "value": "first_item_due",
        "defaultChecked": true,
        "checked": true
    },
    {
        "label": "Status",
        "value": "status_code",
        "defaultChecked": true,
        "checked": true
    },
];

export const DocumentSummaryHeader = [
    {
        "label": "Item Name",
        "value": "item_name"
    },
    {
        "label": "Format",
        "value": "format"
    },
    {
        "label": "Due Date",
        "value": "due_date"
    },
    {
        "label": "Status",
        "value": "status"
    },
    {
        "label": "Last Comment(Date)",
        "value": "last_comment"
    },
    {
        "label": "Uploaded Files",
        "value": "upload_file"
    },
    {
        "label": "Actions",
        "value": "actions"
    },
]